import React from "react";
import { formatToolResultAsDocumentList } from "./formatToolResultAsDocumentList";
import { formatToolResultAsKeyValue } from "./formatToolResultAsKeyValue";
import { formatToolResultAsMarkdown } from "./formatToolResultAsMarkdown";
import {
	UIComponent,
	type UIComponent as UIComponentType,
} from "../../../types/uiComponent";

/**
 * Pick the right formatter for a raw tool-result summary based on the
 * `ui_component_type` discriminator the backend attaches to the trace block.
 * Falls back to markdown rendering when the discriminator is unrecognised.
 */
export function formatToolResultBody(
	summary: string,
	uiComponentType: UIComponentType,
): React.ReactNode {
	switch (uiComponentType) {
		case UIComponent.TOOL_RESULT_DOCUMENT_QA:
			return formatToolResultAsDocumentList(summary);
		case UIComponent.TOOL_RESULT_JSON_TREE:
			return formatToolResultAsKeyValue(summary);
		default:
			return formatToolResultAsMarkdown(summary);
	}
}
